import { useQuery } from '@apollo/client';

import { SearchMode } from '@xing-com/crate-common-graphql-types';
import { SEARCH_BOX_MAX_RECENT_SEARCHES } from '@xing-com/crate-jobs-constants';
import { GetRecentSearchesDocument } from '@xing-com/crate-jobs-graphql';

type UseRecentSearchesArgs = {
  skip?: boolean;
  searchMode?: SearchMode;
};

export const useRecentSearches = ({
  skip,
  searchMode = SearchMode.Normal,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
}: UseRecentSearchesArgs) => {
  const { data, loading, refetch } = useQuery(GetRecentSearchesDocument, {
    variables: {
      consumer: 'loggedin.web.jobs.search',
      limit: SEARCH_BOX_MAX_RECENT_SEARCHES,
      searchMode,
    },
    skip,
  });

  return {
    isLoading: loading,
    recentSearches: data?.viewer?.jobRecentSearchesJS?.searches,
    refetch,
  };
};
